import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { CdisationData } from '@models/api/requests';

@Component({
    selector: 'app-informations-renouvellement-form',
    imports: [
        CommonModule,
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule,
        MatStepperModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatDividerModule,
        MatRadioModule,
        MatTableModule
    ],
    templateUrl: './informations-renouvellement-form.component.html',
    styleUrls: ['./informations-renouvellement-form.component.scss']
})
export class InformationsRenouvellementFormComponent implements OnInit {
  @Input() infoRenouvellementForm!: FormGroup;
  @Input() cdisationData!: CdisationData;
  @Output() formSubmit = new EventEmitter<FormGroup>();

  showRefusConfirmation = false;

  constructor(private readonly fb: FormBuilder) {}

  ngOnInit() {
    // Listen to motif changes
    this.infoRenouvellementForm.get('motif')?.valueChanges.subscribe((value) => {
      this.handleMotifChange(value);
    });
  }

  private handleMotifChange(motif: string) {
    const confirmRefusControl = this.infoRenouvellementForm.get('confirmRefus');

    if (motif === 'refusContratDemande') {
      // Update the existing control with the required validator
      confirmRefusControl?.setValidators(Validators.requiredTrue);
      confirmRefusControl?.setValue(false);
      confirmRefusControl?.updateValueAndValidity();
      this.showRefusConfirmation = true;
    } else {
      // Remove validators when not in refus mode
      confirmRefusControl?.clearValidators();
      confirmRefusControl?.updateValueAndValidity();
      this.showRefusConfirmation = false;
    }
  }

  isMotifDisabled(motif: string): boolean {
    if (this.cdisationData.flagCdisation) {
      // motifs that are never disabled
      return motif !== 'contratConditionsDiffs' && motif !== 'refusContratDemande' && motif !== 'refusContratConditions';
    }
    return false;
  }

  onSubmit() {
    if (this.infoRenouvellementForm.valid) {
      this.formSubmit.emit(this.infoRenouvellementForm);
    }
  }

  onReset() {
    this.infoRenouvellementForm.reset();
  }
}
